import Vue from 'vue';
import { lsI18nService } from 'ls-vue-common';
import { lsInternationalizationHelpers } from '@/helpers';

//eslint-disable-next-line import/prefer-default-export
export const internationalizationMixin = Vue.mixin({
  created() {
    lsInternationalizationHelpers.initI18n();
  },
  methods: {
    t(key, params) {
      return lsI18nService.translate(key, params);
    },
    setLocale(locale) {
      return lsI18nService.setLocale(locale);
    },
    getLocale() {
      return lsI18nService.getLocale();
    },
  },
});
